import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
      themes: {
        dark: {
          primary: '#3881ff',
        },
      },
      dark: true,
    },
    icons: {
        iconfont: 'mdi',
      },
})
